import {
  AnimalCard,
  ExtensionType,
  SimplifiedExtensionCard,
} from './ExtensionCard';
import type { MessageDescriptor } from '../i18n/messages';

export enum RoomState {
  pending = 'pending',
  playing = 'playing',
}

export enum GameStage {
  placing = 'placing',
  eating = 'eating',
  extinction = 'extinction',
  end = 'end',
}

export enum HandType {
  human = 'human',
  poc = 'poc',
  stick = 'stick',
  material = 'material',
  altushka = 'altushka',
  cat = 'cat',
}

export type BotDifficulty = 'easy' | 'medium' | 'hard';

export type GameState = {
  step: number;
  stage: GameStage;
  activeUser: string | '*' | 'none';
  ready: string[];
  foodOnTheTable: number;
  cardsLeft: number;
  results?: Array<{ playerId: string; score: number }>;
  additionalResults?: MessageDescriptor[];
  timePerSteps: number[];
  timePerStepsAverage?: number;
  cycleStartedAt?: number;
  cardsPerSteps: number[];
  cardsPerStepsAverage?: number;
};

export type Player = {
  id: string;
  cards: AnimalCard[];
  deck: SimplifiedExtensionCard[];
  meta: { name?: string };
  handType: HandType;
  avatarHash?: string;
  isBot: boolean;
  botDifficulty?: BotDifficulty | null;
};

export type DisabledCards = Partial<Record<ExtensionType, boolean>>;

export type RoomSettings = {
  /** Cards per player at the start of the game */
  cardsPerUserInitial: number;
  /** Cards per player's animal after feeding ends */
  cardsPerUserAliveAnimal: number;
  /** Food range at the start of the feeding phase */
  foodAbundance: {
    from: number;
    to: number;
  };
  /** Total cards in the deck */
  totalCardLimit: number;
  /** Cards that will not be used */
  disabledCards: DisabledCards;
};

export type Room<TPlayer = Player> = {
  name: string;
  state: RoomState;
  gameState: GameState;
  settings: RoomSettings;
  players: TPlayer[];
  commonExtensions: SimplifiedExtensionCard[];
  actions: number;
  isPublic: boolean;
};

export type SimpleRoom = {
  name: string;
  playersCount: number;
};
